import { europeFunctions } from "./Firebase"

export const processImage = async data => {
  return await callFirebaseFunction("general-processImage", data)
}

export const defaultProcessImage = async ({ width, path }) => {
  return await processImage({
    params: {
      resize: { width: width || 1200 },
      jpeg: { quality: 60, progressive: true },
      sharpen: true,
      contentType: "image/jpeg",
    },
    bucket: "gs://cityx-cms",
    path: path,
  })
}

export const callFirebaseFunction = async (name, data) => {
  const fbFunction = europeFunctions.httpsCallable(name)
  return await fbFunction(data)
}
